/* Order bump "Skindion Priority+" — popup sobre el drawer de Rebuy Smart Cart.

   Port de la lógica ya probada en México (assets/mgel.js, bloque EPP), con dos
   cambios deliberados:
     1. SIN scope de producto. En MX el popup solo se ofrecía si el carrito
        traía gel; aquí el money model §5 define Priority+ como order bump del
        carrito, sin condicionar a producto. Se ofrece con cualquier carrito
        que no lo lleve ya.
     2. "Una sola vez por SESIÓN" de verdad: MX usaba una variable en memoria,
        que se reinicia en cada carga de página. Aquí va en sessionStorage (con
        espejo en memoria y fallback si el navegador la bloquea), que es lo que
        pidió Mau.

   ── Principio rector: NUNCA bloquear una venta ──────────────────────────────
   El interceptor corre en fase de captura sobre el botón de checkout de Rebuy.
   Si algo falla (sin popup en el DOM, init roto, /cart.js ilegible, variante no
   resoluble), el flujo SIEMPRE acaba en proceedToCheckout(). Un add fallido es
   la única ruta que deja el popup abierto, y ahí no se navega: se muestra el
   error para reintentar.
*/
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  var CHECKOUT_BTN = '.rebuy-cart__checkout-button';
  var SESSION_KEY = 'skdppOffered';

  var interceptorBound = false;
  var proceeding = false; /* guard del re-click sintético */
  var offeredMemory = false; /* espejo por si sessionStorage no está */

  function wasOffered() {
    if (offeredMemory) return true;
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false; /* modo privado / storage bloqueado: solo memoria */
    }
  }

  function markOffered() {
    offeredMemory = true;
    try {
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* da igual: offeredMemory ya cubre esta carga de página */
    }
  }

  /* Avisa al theme, a Rebuy y a quien escuche de que la cesta cambió.
     Mismo juego de eventos que js-main-product-protocolo.js: rebuy:cart.change
     es el que oye la Smart Cart. */
  function dispatchCartRefresh() {
    ['rebuy:cart.change', 'cart:refresh', 'cart:build', 'cart:updated'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (e) {
        /* que falte CustomEvent no puede romper el flujo */
      }
    });
  }

  /* Volver al checkout = re-click al propio botón de Rebuy para que corra su
     handler de Vue. El guard `proceeding` hace que el interceptor deje pasar
     este click sintético. Nunca navegamos a /cart. */
  function proceedToCheckout() {
    proceeding = true;
    var btn = document.querySelector(CHECKOUT_BTN);
    if (btn) btn.click();
    proceeding = false;
  }

  /* Días de garantía SIN Priority+ según el carrito (misma regla que el "labio" del
     drawer en js-rebuy-garantia.js): gel automático = Protocolo Firmeza → 60; Kit Spa
     Facial → 60; dispositivo suelto = Kit Esencial → 30. Sin dispositivo ni kit → 60
     (= el default server-side del snippet). */
  var GEL_AUTO = 'gel-hidratante-200g-auto';
  var KIT_SPA = /beauty-kit/;
  var DISPOSITIVO = /(^skindion-(rosa|negro)$)|^dispositivo-de-/;
  function diasGarantia(cart) {
    var items = (cart && cart.items) || [];
    var dias = 0;
    for (var i = 0; i < items.length; i++) {
      var h = String(items[i].handle || '').toLowerCase();
      if (h === GEL_AUTO || KIT_SPA.test(h)) dias = Math.max(dias, 60);
      else if (DISPOSITIVO.test(h)) dias = Math.max(dias, 30);
    }
    return dias || 60;
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items || isNaN(variantId)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return true;
    }
    return false;
  }

  function initPopup(root) {
    if (!root || root.dataset.skdppInit === '1') return;
    root.dataset.skdppInit = '1';

    var overlay = root.querySelector('[data-skdpp-overlay]');
    var dialog = root.querySelector('[data-skdpp-dialog]');
    var closeBtn = root.querySelector('[data-skdpp-close]');
    var acceptBtn = root.querySelector('[data-skdpp-accept]');
    var acceptLabel = root.querySelector('[data-skdpp-accept-label]');
    var declineBtn = root.querySelector('[data-skdpp-decline]');
    var errorEl = root.querySelector('[data-skdpp-error]');
    var variantId = parseInt(root.getAttribute('data-skdpp-variant'), 10);

    if (!dialog || !acceptBtn) return;

    var lastFocused = null;
    var keydownHandler = null;
    var submitting = false;
    var closeTimer = null;

    function setLoading(on) {
      if (on) {
        acceptBtn.setAttribute('disabled', 'disabled');
        acceptBtn.setAttribute('aria-busy', 'true');
        acceptBtn.classList.add('is-loading');
        if (acceptLabel) {
          acceptLabel.textContent = acceptBtn.getAttribute('data-label-loading') || 'Añadiendo…';
        }
      } else {
        acceptBtn.removeAttribute('disabled');
        acceptBtn.removeAttribute('aria-busy');
        acceptBtn.classList.remove('is-loading');
        if (acceptLabel) {
          acceptLabel.textContent =
            acceptBtn.getAttribute('data-label-default') || acceptLabel.textContent;
        }
      }
    }

    function showError(msg) {
      if (errorEl) errorEl.textContent = msg || 'No se pudo añadir a la cesta. Inténtalo de nuevo.';
    }
    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    /* Escribe los días de garantía sin Priority+ en la tabla ([data-skdpp-dias]). */
    function setDias(dias) {
      if (!dias) return;
      var s = String(dias);
      Array.prototype.forEach.call(root.querySelectorAll('[data-skdpp-dias]'), function (el) {
        if (el.textContent !== s) el.textContent = s;
      });
    }

    function open(trigger, dias) {
      if (!root.hidden && !closeTimer) return;
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      lastFocused = trigger || document.activeElement;
      clearError();
      setDias(dias);

      root.hidden = false;
      void root.offsetWidth; /* reflow: la transición corre desde el estado abierto */
      root.classList.add('is-open');
      document.documentElement.classList.add('skdpp-modal-lock');

      keydownHandler = onKeydown;
      document.addEventListener('keydown', keydownHandler, true);
      (closeBtn || dialog).focus();
    }

    function close() {
      if (root.hidden || closeTimer) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('skdpp-modal-lock');

      if (keydownHandler) {
        document.removeEventListener('keydown', keydownHandler, true);
        keydownHandler = null;
      }
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        root.hidden = true;
      }, 200);

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }

    /* Todo cierre continúa al checkout. Solo "Añadir" cambia el resultado: no
       hay ruta "quedarse en el carrito" desde aquí (mismo criterio que MX). */
    function closeAndProceed() {
      close();
      proceedToCheckout();
    }

    function trapFocus(e) {
      var focusables = Array.prototype.slice
        .call(dialog.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (focusables.length === 0) {
        e.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !dialog.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else if (active === last || !dialog.contains(active)) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        markOffered();
        closeAndProceed();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    }

    function onAccept() {
      if (submitting) return;
      if (isNaN(variantId)) {
        /* Variante no resoluble: jamás bloquear la venta. */
        markOffered();
        closeAndProceed();
        return;
      }
      submitting = true;
      clearError();
      setLoading(true);

      window
        .fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { _priority_via: 'popup' } }]
          })
        })
        .then(function (res) {
          if (!res.ok) {
            return res
              .json()
              .catch(function () {
                return null;
              })
              .then(function (body) {
                throw new Error((body && body.description) || 'cart_add_failed');
              });
          }
          return res.json();
        })
        .then(function () {
          /* Atributo de carrito para poder atribuir el add-on al popup desde
             Flow/analítica. Best-effort: si falla, Priority+ ya está dentro y
             el cliente pidió ir al checkout, así que se sigue igual. */
          return window
            .fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ attributes: { _priority_via: 'popup' } })
            })
            .catch(function () {});
        })
        .then(function () {
          dispatchCartRefresh();
          setLoading(false);
          submitting = false;
          markOffered();
          closeAndProceed();
        })
        .catch(function (err) {
          /* Add fallido: restaurar botón, mostrar error y dejar el popup
             abierto para reintentar. Nunca navegar tras un add fallido. */
          setLoading(false);
          submitting = false;
          showError(err && err.message && err.message !== 'cart_add_failed' ? err.message : null);
        });
    }

    root.skdppOpen = open;

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        markOffered();
        closeAndProceed();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', function () {
        markOffered();
        closeAndProceed();
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        markOffered();
        closeAndProceed();
      });
    }
    acceptBtn.addEventListener('click', onAccept);
  }

  /* Interceptor en fase de captura del botón de checkout de Rebuy. Bloquea
     PRIMERO (síncrono, antes de cualquier await) y luego decide async si abrir
     el popup, de-duplicar o dejar pasar. */
  function onCheckoutClickCapture(e) {
    var btn = e.target && e.target.closest ? e.target.closest(CHECKOUT_BTN) : null;
    if (!btn) return;
    if (proceeding) return; /* nuestro propio re-click */
    if (wasOffered()) return; /* ya ofrecido en esta sesión */

    var root = document.querySelector('[data-skdpp-popup]');
    if (!root) return; /* sin popup en el DOM: jamás bloquear la venta */

    try {
      e.preventDefault();
      e.stopImmediatePropagation();
    } catch (blockErr) {
      markOffered();
      return;
    }

    var variantId = parseInt(root.getAttribute('data-skdpp-variant'), 10);

    var openOrProceed = function (dias) {
      if (typeof root.skdppOpen === 'function') {
        root.skdppOpen(btn, dias);
      } else {
        markOffered();
        proceedToCheckout();
      }
    };

    window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        /* Carrito vacío: no hay nada que priorizar. */
        if (!cart || !cart.items || cart.items.length === 0) {
          markOffered();
          proceedToCheckout();
          return;
        }
        /* De-dup: si Priority+ ya está dentro, no re-ofrecer nunca. */
        if (cartHasVariant(cart, variantId)) {
          markOffered();
          proceedToCheckout();
          return;
        }
        openOrProceed(diasGarantia(cart));
      })
      .catch(function () {
        /* /cart.js ilegible: no dejar al cliente varado en el drawer. Se abre
           igual; un doble add se de-duplica en el carrito del server. */
        openOrProceed();
      });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-skdpp-popup]'), initPopup);
    if (!interceptorBound) {
      document.addEventListener('click', onCheckoutClickCapture, true);
      interceptorBound = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Editor del theme: re-init en load, y quitar el listener en unload para que
     no se acumule entre ciclos. */
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    if (target.querySelectorAll) {
      Array.prototype.forEach.call(target.querySelectorAll('[data-skdpp-popup]'), initPopup);
    }
    if (!interceptorBound) {
      document.addEventListener('click', onCheckoutClickCapture, true);
      interceptorBound = true;
    }
  });
  document.addEventListener('shopify:section:unload', function () {
    if (interceptorBound) {
      document.removeEventListener('click', onCheckoutClickCapture, true);
      interceptorBound = false;
    }
  });
})();
